import styled from '@emotion/styled';
import { GrayColors, PrimaryColors } from '@revenuemarket/cds/colors';

export const LabelWrapper = styled.label<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  gap: 6px;
  &:hover > div > span {
    ${({ disabled }) => !disabled && `box-shadow: 0 0 0 3px ${GrayColors.grayOpacity07};`}
  }
`;

export const CheckboxWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 3px;
`;

export const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  &:focus-visible + span {
    box-shadow: 0 0 0 3px ${PrimaryColors.primaryOpacity36};
    z-index: 1;
  }
  &:focus-visible:hover + span {
    box-shadow: 0 0 0 3px ${PrimaryColors.primaryOpacity45};
  }
`;

export const StyledCheckbox = styled.span<{
  checked: boolean;
  disabled: boolean;
  boxSize: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ boxSize }) => boxSize}px;
  height: ${({ boxSize }) => boxSize}px;
  border-radius: ${({ boxSize }) => (boxSize >= 18 ? 6 : 4)}px;
  border: 1.5px solid
    ${({ checked, disabled }) =>
      disabled
        ? GrayColors.grayOpacity22
        : checked
          ? PrimaryColors.primary600
          : GrayColors.gray300};
  background: ${({ checked, disabled }) =>
    disabled ? GrayColors.gray200 : checked ? PrimaryColors.primary600 : '#fff'};
  box-sizing: border-box;
  margin-right: 0px;
  svg {
    display: block;
    pointer-events: none;
  }
  &:hover {
    ${({ disabled }) => !disabled && `box-shadow: 0 0 0 3px ${PrimaryColors.primaryOpacity36};`}
  }
  input:focus-visible + & {
    box-shadow: 0 0 0 3px ${PrimaryColors.primaryOpacity36};
  }
`;
